import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './index.css';
import './css/App.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initializeNative } from './utils/native';
import { initPlausible } from './utils/analytics';
import { captureAttributionOnce } from './utils/attribution';
import { initTestMode } from './utils/testMode';

// Error tracking — no-op unless REACT_APP_SENTRY_DSN is set at build time, so
// this is safe to ship before a Sentry project exists.
if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.REACT_APP_SENTRY_ENV || 'production',
    release: process.env.REACT_APP_SENTRY_RELEASE || undefined,
    tracesSampleRate: 0.05,
    // Session Replay off by default; enable later if desired.
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
  });
}

// Test mode: capture ?test=<token> early so the X-WL-Test-Token header is sent
// on the very first API requests (owner self-exclusion from analytics).
initTestMode();

// Initialize native platform features (Capacitor)
initializeNative().catch(console.error);

// Initialize Plausible analytics (cookieless, no consent needed)
initPlausible();

// Capture first-touch acquisition (UTM params + referrer) once per browser,
// for the unit-economics funnel's source breakdown. Best-effort, fire-and-forget.
captureAttributionOnce();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Real-user page-load timings -> /api/pulse/e/ (web_vitals events).
reportWebVitals();
